import { NgModule } from '@angular/core';
import { PhDropComponent } from '@shared/components/ph-drop/ph-drop.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [PhDropComponent],
  exports: [PhDropComponent],
  imports: [CommonModule],
})
export class PhDropModule {}
